<script lang="ts">

    import 'mapbox-gl/dist/mapbox-gl.css';
    import { Map as Mapbox, LngLatLike, LngLatBoundsLike, FitBoundsOptions, LngLatBounds } from 'mapbox-gl';
    import { onMount, setContext } from 'svelte';
    import { MAPBOXACCESSTOKEN, DEFAULTMAPZOOM, MAPBOXSTYLE } from '../evironment';
    import type { Coords } from '../interfaces';

    export let center: Coords = undefined;

    export let bounds: LngLatBounds | [LngLatBounds, FitBoundsOptions] = undefined;

    let mapContainer: HTMLElement;
    let map: Mapbox;
    let mapIsReady = false;

    setContext('getMap', () => map);

    $: panTo(center, map);
    $: updateBounds(mapIsReady, bounds);

    onMount(() => {

        map = new Mapbox({
            accessToken: MAPBOXACCESSTOKEN,
            container: mapContainer,
            style: MAPBOXSTYLE,
            center: {lng: center.lon, lat: center.lat} as LngLatLike,
            zoom: DEFAULTMAPZOOM
        });

        map.once('load', () => mapIsReady = true);
        
        setTimeout(() => map.resize(), 2000);

    });

    function updateBounds(mapIsReady: boolean, bounds: LngLatBounds | [LngLatBounds, FitBoundsOptions]): void {
        if (!mapIsReady || !bounds) {
            return;
        }
        let options: FitBoundsOptions;
        if (Array.isArray(bounds)) {
            options = bounds[1];
            bounds = bounds[0];
        }
        map.fitBounds(bounds, options);
    }

    export function fitBounds(bounds: LngLatBoundsLike, options?: FitBoundsOptions): void {
        if (!map) {
            return;
        }
        map.fitBounds(bounds, options);
    }

    export function getBounds(): LngLatBounds {
        return map.getBounds();
    }

    function panTo(center: Coords, map: Mapbox): void {
        
        if (!map || !center) {
            return;
        }

        map.panTo({lng: center.lon, lat: center.lat} as LngLatLike, {
            duration: 500,
        });
        
    }

</script>

<div class="map-container" bind:this={mapContainer}></div>

{#if mapIsReady}
    <slot />
{/if}

<style lang="scss">

    .map-container {
        width: 100%;
        height: 100%;
    }

</style>
